<template>
    <div class="card">
        <div class="card-block">
            <h6 class="card-title mb-0">Комментарии к заказу</h6>
            <template v-if="order.canOrderViewComments">
            <loading v-if="loading" message="Загружаем комментари..."></loading>
            <div v-else class="chat-box">
                <ul class="chat-list" v-if="comments && comments.length > 0">
                    <template v-for="(comment, index) in comments">
                        <li v-if="comment.user.id === user.id" class="chat-item odd">
                            <div class="chat-content">
                                <template v-if="firstCommentUser(comment.user, index)">
                                    <h5>Вы</h5>
                                    <div class="small chat-diff-for-hummans">{{comment.diffForHumans}} - {{comment.date}}</div>
                                </template>
                                <div class="box bg-light-inverse">{{comment.text}}</div>
                            </div>
                            <div class="chat-time">{{comment.time}}</div>
                        </li>
                        <li v-else class="chat-item" :class="{ 'chat-new': !comment.isViewed }">
                            <div class="chat-img"><img :src="getAvatarPath(comment.user.avatar)" alt="user"></div>
                            <div class="chat-content">
                                <h5>{{comment.user.fullname}}</h5>
                                <div class="small chat-diff-for-hummans">{{comment.diffForHumans}} - {{comment.date}} </div>
                                <div class="box bg-light-info">{{comment.text}}</div>
                            </div>
                            <div class="chat-time">{{comment.time}}</div>
                        </li>
                    </template>
                </ul>
                <div v-else class="alert alert-warning mt-2">
                    Пока никто не оставлял комментарии.
                </div>
            </div>
            </template>
            <div v-else class="alert alert-warning mt-1">
                У вас недостаточно прав доступа для просмотра комментариев к этому заказу.
            </div>
        </div>
        <div class="card-footer" v-if="order.canOrderAddComments">
            <loading v-if="sendLoading" :size="2" :message="false"></loading>
            <form v-else @submit.prevent="beforeSend">
                <div class="input-group" :class="{ 'has-danger': $v.commentText.$error }">
                    <input type="text" v-model.trim='commentText' @input="$v.commentText.$touch()" class="form-control" placeholder="Введите текст комментария" autofocus>
                    <span class="input-group-btn">
                        <button :class="{ 'disabled': $v.commentText.$invalid }" :disabled="$v.commentText.$invalid" type="submit" class="btn btn-success">Опубликовать</button>
                    </span>
                </div>
                <span class="small help-block text-danger" v-if="$v.commentText.$error">Минимальна длинна комментария {{$v.commentText.$params.minLength.min}} символа</span>
            </form>
        </div>
    </div>
</template>
<script>
  import { storageUrl } from './../config'
  import { required, minLength } from 'vuelidate/lib/validators'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    name: 'comments',
    props: ['order'],
    data () {
      return {
        sendLoading: false,
        commentText: ''
      }
    },
    computed: mapState({
      user: state => state.globalStore.user,
      loading: state => state.commentStore.loading,
      comments: state => state.commentStore.comments
    }),
    methods: {
      /**
       * Метод возвращает полный пут к аватарке пользователя
       * @param path
       * @return {string}
       */
      getAvatarPath (path) {
        return storageUrl + path
      },
      /**
       * Метод проверяет предыдущее сообщение того же пользователя или нет
       * @param user
       * @param index
       * @return bool
       */
      firstCommentUser (user, index) {
        let comment = this.comments[index - 1]
        if (comment !== undefined && comment.user.id === user.id) {
          return false
        } else {
          return true
        }
      },
      /**
       * Валидация формы перед отправкой
       */
      beforeSend () {
        this.$v.commentText.$touch()
        if (!this.$v.commentText.$error) {
          this.sendComment()
        }
      },
      /**
       * Отправка комментария
       */
      sendComment () {
        this.sendLoading = true
        const newComment = this.commentText
        this.commentText = ''
        this.$store.dispatch('sendComment', {
          text: newComment,
          orderId: this.order.id
        }).then(() => {
          this.sendLoading = false
          this.addToast({
            text: 'Комментарий успешно опубликован',
            type: 'success',
            position: 'se',
            dismissAfter: 3000
          })
          this.$v.commentText.$reset()
        }).catch((error) => {
          console.log(error)
          this.addToast({
            text: 'Ошибка отправки комментария: ' + error,
            type: 'danger',
            position: 'se',
            dismissAfter: 3000
          })
          this.sendLoading = false
          this.commentText = newComment.text
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    mounted () {
      if (this.order.canOrderViewComments) {
        this.$store.dispatch('getComments', this.order.id)
      }
    },
    validations: {
      commentText: {
        required,
        minLength: minLength(2)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Comments.vue?fc7b4ccc